/**
 * @Description 监听图片资源加载失败时上报sentry
 */

import { useEffect } from 'react';
import { useMethods } from '@lhb/hook';
import * as Sentry from '@sentry/react';

/**
 * @param targetDom 监听指定dom元素下的图片资源
 * @param extraData 额外需要上报到sentry的字段
 */
export function useImgOnErrorOfSentry(targetDom: any, extraData: Object) {
  useEffect(() => {
    if (!targetDom) return;
    targetDom.querySelectorAll('img').forEach(img => {
      img.addEventListener('error', methods.handleImageError);
    });
    // 清理函数，组件卸载时移除事件监听
    return () => {
      targetDom.querySelectorAll('img').forEach(img => {
        img.removeEventListener('error', methods.handleImageError);
      });
    };
  }, [targetDom]);

  const methods = useMethods({
    handleImageError: (e: any) => {
      const { target } = e || {};
      const { src } = target || {};
      // 开始上报错误
      Sentry.captureEvent({
        message: '图片加载失败',
        level: 'error', // 可以是 'info', 'warning', 'error'
        extra: {
          errorImgUrl: src,
          ...(extraData || {}),
        }
      });
    }
  });
}
